(function () {
  const threshold = 5000;
  const BEAR_VARIANT = '57557119631691';
  const PENGUIN_VARIANT = '57557117731147';
  const PAIR = {
    bear: { title: 'Silikon-Eisformen Bären', price: '7,95 EUR', variantId: BEAR_VARIANT, url: '/products/silikon-eisformen-baren-4-niedliche-eiswurfel' },
    penguin: { title: 'Silikon-Eisformen Pinguine', price: '7,95 EUR', variantId: PENGUIN_VARIANT, url: '/products/silikon-eisformen-pinguine-4-susse-eiswurfel' },
  };
  const upsells = [
    { title: 'Reise-Parfümzerstäuber Set', price: '4,65 EUR', variantId: '57557123006795', url: '/products/reise-parfumzerstauber-set-2-stuck-5-ml-aluminium' },
    { title: 'Make-up Schwämmchen Set', price: '6,75 EUR', variantId: '57558248161611', url: '/products/make-up-schwammchen-set-15-teilig-pink-fuchsia-creme' },
    { title: 'Reiseflaschen-Set 9-in-1', price: '5,70 EUR', variantId: '57557131297099', url: '/products/reiseflaschen-set-9-in-1-kosmetik-behalter-fur-unterwegs' },
  ];

  let refreshTimer;
  let lastSignature = '';
  let upsellIndex = 0;
  let currentUpsells = [];

  function ensureLegacyHidden() {
    if (document.getElementById('amx-hide')) return;
    const s = document.createElement('style');
    s.id = 'amx-hide';
    s.textContent = '#CartDrawer [class*="am-drawer-conv"],#CartDrawer [class*="am-cart-conv"]{display:none!important}';
    (document.head || document.documentElement).appendChild(s);
  }

  function formatMoney(cents) {
    return (Math.max(cents, 0) / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function upsellCardHtml(item) {
    if (!item) return '';
    return `
      <div class="amx-item">
        <a href="${item.url}">${item.title}<small>${item.price} · Auffüller</small></a>
        <button type="button" data-amx-add="${item.variantId}">Dazu</button>
      </div>
    `;
  }

  function render(cart) {
    ensureLegacyHidden();
    const footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer || !cart) return;

    const items = cart.items || [];
    const ids = items.map((i) => String(i.variant_id || i.id));
    const hasBear = ids.includes(BEAR_VARIANT);
    const hasPenguin = ids.includes(PENGUIN_VARIANT);

    let pair = null;
    if (hasBear && !hasPenguin) pair = PAIR.penguin;
    else if (hasPenguin && !hasBear) pair = PAIR.bear;
    const pairKey = pair ? pair.variantId : 'none';

    currentUpsells = upsells.filter((u) => !ids.includes(String(u.variantId)));
    if (upsellIndex >= currentUpsells.length) upsellIndex = 0;

    const remaining = threshold - cart.total_price;
    const progress = Math.min(100, Math.max(0, Math.round((cart.total_price / threshold) * 100)));
    const signature = `${cart.item_count}:${cart.total_price}:${progress}:${pairKey}:${currentUpsells.length}`;
    const existing = footer.querySelector('.amx-conv');
    if (existing && signature === lastSignature) return;
    if (existing) existing.remove();
    lastSignature = signature;

    let message = 'Lege direkt los: kostenloser Versand ab 50 EUR.';
    if (cart.item_count && remaining > 0) message = `Noch ${formatMoney(remaining)} bis kostenloser Versand.`;
    if (cart.item_count && remaining <= 0) message = 'Geschafft: kostenloser Versand ist erreicht.';

    const pairHtml = pair
      ? `
        <div class="amx-pair">
          <div><a href="${pair.url}">🐻🐧 Passt perfekt dazu: ${pair.title}<small>${pair.price} · das süße Gegenstück im Glas</small></a></div>
          <button type="button" data-amx-add="${pair.variantId}">Dazu</button>
        </div>
      `
      : '';

    const carouselHtml = currentUpsells.length
      ? `
        <div class="amx-h">Schnell dazu legen</div>
        <div class="amx-carousel">
          ${currentUpsells.length > 1 ? '<button type="button" class="amx-nav" data-amx-prev aria-label="Vorheriges Produkt">‹</button>' : ''}
          <div class="amx-list" id="amx-list">${upsellCardHtml(currentUpsells[upsellIndex])}</div>
          ${currentUpsells.length > 1 ? '<button type="button" class="amx-nav" data-amx-next aria-label="Nächstes Produkt">›</button>' : ''}
        </div>
      `
      : '';

    const block = document.createElement('div');
    block.className = 'amx-conv';
    block.innerHTML = `
      <style>
        #CartDrawer [class*="am-drawer-conv"],#CartDrawer [class*="am-cart-conv"]{display:none!important}
        .amx-conv{display:grid;gap:12px;margin:0 0 16px;padding:14px;border:1px solid rgba(0,0,0,.12);border-radius:10px;background:#fbf8f3}
        .amx-conv strong{font-size:14px;line-height:1.3}
        .amx-trust{display:flex;flex-wrap:wrap;gap:6px;font-size:11px;color:rgba(0,0,0,.68)}
        .amx-trust span{border:1px solid rgba(0,0,0,.1);border-radius:999px;background:#fff;padding:4px 7px}
        .amx-bar{overflow:hidden;height:7px;border-radius:999px;background:rgba(0,0,0,.1)}
        .amx-fill{display:block;height:100%;border-radius:inherit;background:linear-gradient(135deg,#7a1f3d,#e85a7b)}
        .amx-pair{display:grid;grid-template-columns:1fr auto;gap:10px;align-items:center;padding:10px 12px;border:1px solid #7a1f3d;border-radius:8px;background:#fff}
        .amx-pair a{color:inherit;text-decoration:none;font-weight:700;font-size:13px;line-height:1.25}
        .amx-pair small{display:block;color:rgba(0,0,0,.62);font-size:12px;font-weight:400;margin-top:2px}
        .amx-pair button{min-height:34px;border:0;border-radius:6px;background:#7a1f3d;color:#fff;padding:0 14px;font-weight:700;cursor:pointer}
        .amx-h{font-size:12px;font-weight:700;color:rgba(0,0,0,.7)}
        .amx-carousel{display:grid;grid-template-columns:auto 1fr auto;gap:6px;align-items:center}
        .amx-nav{height:34px;width:30px;border:1px solid rgba(0,0,0,.15);border-radius:6px;background:#fff;font-size:18px;line-height:1;cursor:pointer;color:#7a1f3d}
        .amx-list{display:grid;gap:8px}
        .amx-item{display:grid;grid-template-columns:1fr auto;gap:8px;align-items:center;padding:9px;border:1px solid rgba(0,0,0,.1);border-radius:8px;background:#fff}
        .amx-item a{color:inherit;text-decoration:none;font-weight:700;font-size:13px;line-height:1.25}
        .amx-item small{display:block;color:rgba(0,0,0,.62);font-size:12px;margin-top:2px}
        .amx-item button{min-height:34px;border:0;border-radius:6px;background:#7a1f3d;color:#fff;padding:0 10px;font-weight:700;cursor:pointer}
      </style>
      <strong>${message}</strong>
      <div class="amx-bar" aria-hidden="true"><span class="amx-fill" style="width:${progress}%"></span></div>
      <div class="amx-trust" aria-label="Shop Vorteile"><span>DHL 1-3 Werktage</span><span>30 Tage Rückgabe</span><span>Sicher bezahlen</span></div>
      ${pairHtml}
      ${carouselHtml}
    `;
    footer.insertBefore(block, footer.firstElementChild);
  }

  async function refresh() {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      render(await response.json());
    } catch (error) {}
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 150);
  }

  document.addEventListener('click', async (event) => {
    const prev = event.target.closest('[data-amx-prev]');
    const next = event.target.closest('[data-amx-next]');
    if (prev || next) {
      event.preventDefault();
      if (!currentUpsells.length) return;
      upsellIndex = (upsellIndex + (next ? 1 : -1) + currentUpsells.length) % currentUpsells.length;
      const list = document.getElementById('amx-list');
      if (list) list.innerHTML = upsellCardHtml(currentUpsells[upsellIndex]);
      return;
    }
    const button = event.target.closest('[data-amx-add]');
    if (!button) return;
    button.disabled = true;
    button.textContent = '...';
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: button.dataset.amxAdd, quantity: 1 }) });
      window.location.href = '/cart';
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Dazu';
    }
  });

  document.addEventListener('DOMContentLoaded', () => { ensureLegacyHidden(); scheduleRefresh(); });
  document.addEventListener('cart:updated', scheduleRefresh);
  document.addEventListener('DOMContentLoaded', () => {
    const target = document.querySelector('cart-drawer') || document.body;
    const observer = new MutationObserver(scheduleRefresh);
    observer.observe(target, { childList: true, subtree: true });
  });
})();
